module.exports = __webpack_public_path__ + "f9d1f92380f730c6b7de5ce5f4d65059.jpg";